import { Link } from "react-router-dom";
import { TERMS, TERMS_VERSION } from "@/lib/terms";
import { useSeo, pageSeo } from "@/lib/seo";

const SEO = pageSeo("/terms");

export function TermsList() {
  return (
    <div className="flex flex-col gap-5 text-sm">
      {TERMS.map(([t, d]) => (
        <section key={t}><h2 className="text-base font-semibold text-[#0B2A4A]">{t}</h2><p className={`mt-1 leading-relaxed ${d.startsWith("[") ? "italic text-slate-400" : "text-slate-600"}`}>{d}</p></section>
      ))}
    </div>
  );
}

export function CourseTerms({ checked, onChange, slot }) {
  return (
    <label className="flex items-start gap-2 text-sm text-slate-700 cursor-pointer" data-testid={`terms-row-${slot}`}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-0.5 h-4 w-4 accent-[#0070BA]" data-testid={`terms-checkbox-${slot}`} />
      <span>I have read and accept the{" "}
        <Link to="/terms" target="_blank" className="font-semibold text-[#0070BA] underline" data-testid={`terms-open-${slot}`}>course terms</Link>, including the no-refund, one-free-date-change policy.
      </span>
    </label>
  );
}

export default function TermsPage() {
  useSeo(SEO);
  return (
    <section className="max-w-3xl mx-auto px-4 sm:px-8 py-14" data-testid="terms-page">
      <p className="font-mono-ui text-xs tracking-[0.3em] text-[#1A9AA8]">DIGITAL NOMAD NICARAGUA</p>
      <h1 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-[#0B2A4A]">Course terms</h1>
      <p className="mt-3 text-sm text-slate-500">Version {TERMS_VERSION}</p>
      <div className="mt-10"><TermsList /></div>
    </section>
  );
}
